module.exports = __webpack_public_path__ + "img/Bolsa-de-trabajo.7b64cc16.png";